var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 100,
    viewBox: "0 0 88 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61 16.9643C61 20.9119 59.6488 24.5445 57.3828 27.4268L46.6959 45.2329C45.1928 47.7373 41.5376 47.6615 40.1397 45.0968L30.2259 26.9091C28.1965 24.1149 27 20.679 27 16.9643C27 7.59516 34.6112 0 44 0C53.3888 0 61 7.59516 61 16.9643ZM44.0001 24.2346C48.0238 24.2346 51.2858 20.9795 51.2858 16.9642C51.2858 12.9488 48.0238 9.69378 44.0001 9.69378C39.9763 9.69378 36.7143 12.9488 36.7143 16.9642C36.7143 20.9795 39.9763 24.2346 44.0001 24.2346Z",
    fill: "#EF3340"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.555557,
    y: 0,
    width: 86.8889,
    height: 99.9555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 26.4444
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.2222
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.937255 0 0 0 0 0.2 0 0 0 0 0.25098 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.61c3e744792d5a33698b62741fad48e4.svg";
export { ForwardRef as ReactComponent };